import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    void navigate('/');
  };

  return (
    <div>
      <h1>404 Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <Button type='primary' onClick={handleHomeClick}>
        ホームに戻る
      </Button>
    </div>
  );
};

export default NotFoundPage;
